import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterByCategory",
})

export class FilterByCategoryPipe implements PipeTransform {
  public transform( value: any[], searchString: any[] ) {
   if (!searchString) {
     return value;
   }

   const searchStringFormatted = searchString.map((s) => {
    return s.id;
   });

   return value.filter( (it) => {
     const hasCategory = it.serviceCategories ? it.serviceCategories.some((c) => searchStringFormatted.some((s) => s === c.id) ) : false;
     return (hasCategory);
   });
  }
}
